export default "__VITE_ASSET__b_Ex3372__"